import { LINKEDIN_FOLLOWER_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function ldNewFollowers(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case LINKEDIN_FOLLOWER_SUCCESS:
     
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}